import React from "react";
import clsx from "clsx";

export interface ButtonComplexProps {
  label: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  className?: string;
  children?: React.ReactNode;
}

export function ButtonComplex({
  label,
  icon,
  onClick,
  className,
  children,
}: ButtonComplexProps) {
  return (
    <div
      className={clsx(
        "items-center justify-between gap-3 py-2 pl-3 pr-2 border rounded cursor-pointer border-extra-light",
        className
      )}
      onClick={onClick}
    >
      <div className="flex items-center gap-1 text-sm text-gray-extra-dark text-nowrap">
        {label}
      </div>
      <div className="flex items-center gap-2">
      {children}
      {icon && (
        <div className="flex justify-center items-center gap-2.5 rounded-sm w-7 h-7 bg-gray-light">
          {icon}
        </div>
      )}</div>
    </div>
  );
}

export default ButtonComplex;
